export const EXECUTIVE_SUMMARY_SUB_KEYS = {
  LEADS: "leads",
  SUMMARIES: "summaries",
  TOP3: "top3",
  TREND: "trend",
} as const;

export type ExecutiveSummarySubKey =
  (typeof EXECUTIVE_SUMMARY_SUB_KEYS)[keyof typeof EXECUTIVE_SUMMARY_SUB_KEYS];

export const EXECUTIVE_SUMMARY_TREND_MONTHS = 6;
